import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useState,
} from "react";
import { useReactToPrint } from "react-to-print";

const Printable = forwardRef(
  (
    { children, reportTitle, companyName, data, documentTitle = "Document" },
    ref
  ) => {
    const contentRef = useRef(null);

    const handlePrint = useReactToPrint({
      contentRef,
      documentTitle,
      data,
      // pageStyle: "@page { size: A4; margin: 0; }",

      removeAfterPrint: true,
    });

    useImperativeHandle(ref, () => ({
      handlePrint,
    }));

    return (
      <>
        <div
          ref={contentRef}
          style={{
            color: "#000",
            display: "flex",
            flexDirection: "column",
            minHeight: "1000px", // Approx A4 height in px at 96dpi
            // padding: "20px",
          }}
        >
          {companyName && <div style={styles.header}>{companyName}</div>}
          {reportTitle && <div style={styles.header}>{reportTitle}</div>}

          <div style={{ flex: 1 }}>{children}</div>

          {/* <div
            style={{ textAlign: "right", marginTop: "auto", marginRight: 40 }}
          >
            Printed At: {new Date().toLocaleString()}
          </div> */}
        </div>
      </>
    );
  }
);

Printable.displayName = "Printable";

const styles = {
  header: {
    textAlign: "center",
    fontSize: 22,
    fontWeight: "bold",
    padding: 10,
    borderBottom: "2px solid #000",
  },
};

export default Printable;
